<template>
  <div style="height: 100%">
    <div class="research-pc-body">
      <div class="body">
          <div class="title">{{research.title}}</div>
          <!-- <div class="brief">{{research.brief}}</div> -->
          <div class="research-content">
            <div class="left">
              <div class="group-title">{{research.title}}</div>
              <div class="group-item" v-for="(item) in research.list" :key="item.group" @click="onChooseGroup(item)">
                  <div :class="selectedGroup.group != item.group ? 'group-normal' : 'group-selected'">{{item.group}}</div>
              </div>
            </div>
            <div class="right">
              <div class="right-title">{{selectedGroup.group}}</div>
              <div class="research-item" >
                <!-- <img class="img" :src="require('../../static/pic/' + imagePath)" v-for="imagePath in selectedGroup.imagelist" v-if="imagePath.length > 0" :key="imagePath"/> -->
                  <!-- <div>{{selectedGroup.content}}</div> -->
                  <div class="detail" v-for="(item, index) in selectedGroup.datalist" :key="index">
                    <div class="subTitle" v-if="item.subTitle">{{item.subTitle}}</div>
                    <div class="info" v-if="item.info">{{item.info}}</div>
                    <img :src="'static/pic/' + item.image" v-if="item.image.length > 0" />
                    <div class="desc" v-if="item.desc">{{item.desc}}</div>
                  </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    <div class="research-mobile-body">
      <div class="header" @click="showMobileMenu()">{{selectedGroup.group}} <i class="el-icon-arrow-down" v-show="!isMobileMenuShow" /><i class="el-icon-arrow-up" v-show="isMobileMenuShow" /></div>
      <div v-if="isMobileMenuShow" class="header-menu">
        <div v-for="(item) in research.list" :key="item.group" @click="onChooseGroup(item)" class="header-menu-item">
          <div :class="selectedGroup.group != item.group ? 'group-normal' : 'group-selected'">{{item.group}}</div>
        </div>
      </div>
      <div class="mobile-body">
        <div class="title">{{selectedGroup.group}}</div>
        <div class="research-content">
            <div class="research-item">
                <!-- <img :src="require('../../static/pic/' + selectedGroup.image)"/> -->
                <!-- <img class="research-item-img" :src="require('../../static/pic/' + imagePath)" v-for="imagePath in selectedGroup.imagelist" v-if="imagePath.length > 0" :key="imagePath"/>
                <div class="item-title">{{selectedGroup.content}}</div> -->
                <div class="detail" v-for="(item, index) in selectedGroup.datalist" :key="index">
                  <div class="subTitle" v-if="item.subTitle">{{item.subTitle}}</div>
                    <div class="info" v-if="item.info">{{item.info}}</div>
                    <img :src="'static/pic/' + item.image" v-if="item.image.length > 0" />
                    <div class="desc" v-if="item.desc">{{item.desc}}</div>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getCurLan} from '@/util/tools'
export default {
  name: 'research-page',
  data () {
    return {
        isMobileMenuShow: false,
        selectedGroup: {
              group:"先进表征技术的研发",
              title: "(一) 超高时空分辨的先进表征技术的研发",
              image: "",
              content: "1). 太赫兹低温扫描隧道显微镜（THz-STM）的研发"
          },
        research:
        {
            title: "研究方向",
            brief: "研究组主要从事表面和新型低维量子材料探索、物性研究。近年来主要关注以下方面：",
            list: [
            {
                title: "(一) 超高时空分辨的先进表征技术的研发",
                image: "",
                content: "1). 太赫兹低温扫描隧道显微镜（THz-STM）的研发"
            }]
        }
    }
  },
  mounted () {
    // this.research = getCurLan().research;
    // this.selectedGroup = this.research.list[0]
    var self = this
    getCurLan().then(res => {
      self.research = res.research
      self.selectedGroup = self.research.list[0]
    })
  },
  methods: {
    clickItem (item) {
      this.$router.push({ name: 'research-detail-page', params: item })
    },
    onChooseGroup (item) {
      this.selectedGroup = item
      if (this.isMobileMenuShow) {
        this.isMobileMenuShow = false
      }
    },
    showMobileMenu () {
      this.isMobileMenuShow = !this.isMobileMenuShow
    }
  }
}
</script>
<style lang='scss' src='../assets/styles/pc/research-page.scss'></style>
<style lang='scss' src='../assets/styles/mobile/research-page.scss'></style>


// WEBPACK FOOTER //
// src/components/Research.vue